import { process_content_for_browser } from "./deobfuscate";
import { KMSGallery } from "./gallery";

export function content_processor(element){
    // This function is called when the page loads to allow any functions that attach
    // event handlers to content to do so. It can also be called by other functions 
    // after inserting content into the page that needs to have event handlers attached.

    KMSGallery(element);
    process_content_for_browser(element);
}